import { useUserOrgData } from '#pplx/frontend/apps/ask/organization/hooks/useUserOrgData.js';
/**
 * Returns true if upsells should be blocked for enterprise users with
 * product_communications_enabled=false. Returns true while loading.
 *
 * `enabled: false` disables the underlying org-data fetch (for callers that
 * gate on a feature flag); the answer then reflects only already-cached org
 * data and still fails closed when none is available.
 */
export const useBlockUpsellForEnterpriseConsent = (options) => {
    const { organization, isEnterprise, isLoading } = useUserOrgData({
        enabled: options?.enabled ?? true,
        reason: 'check-upsell-enterprise-consent',
    });
    if (isLoading) {
        return true;
    }
    if (!isEnterprise) {
        return false;
    }
    return !organization?.settings?.product_communications_enabled;
};
//# sourceMappingURL=useBlockUpsellForEnterpriseConsent.js.map